<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2017 by The University of Chicago</p>
<p class="crtf">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2017</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">26 25 24 23 22 21 20 19 18 17    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-50185-7 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-50199-4 (e-book)</p>
<p class="crt">DOI: 10.7208/chicago/9780226501994.001.0001</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Gere, Cathy, 1964– author.</p>
<p class="cip">Title: Pain, pleasure, and the greater good : from the Panopticon to the Skinner box and beyond / Cathy Gere.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2017. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2017009044 | ISBN 9780226501857 (cloth : alk. paper) | ISBN 9780226501994 (e-book)</p>
<p class="cip">Subjects: LCSH: Utilitarianism—History. | Utilitarianism—England—History. | Utilitarianism—United States—History. | Psychology and philosophy. | Philosophy and science. | Medicine—Philosophy.</p>
<p class="cip">Classification: LCC B843 .G46 2017 | DDC 144/.6—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2017009044" target="_blank">https://lccn.loc.gov/2017009044</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gere-0004.vue?33164e36